<template>
  <div id="content" style="text-align: justify">
    <h2>Informativa sul trattamento dei dati personali</h2>
    <br />
    <h4>1. Premessa</h4>
    <p>
      Ai sensi dell'art. 13 del D.Lgs. n. 196/2003 - “Codice in materia di
      protezione dei dati personali” (di seguito denominato “Codice”), il Sig.
      Claudio De Nardi, in qualità di “Titolare” del trattamento, è tenuto a
      fornirle informazioni in merito all'utilizzo dei suoi dati personali.
    </p>

    <h4>2. Fonte dei dati personali</h4>
    <p>
      La raccolta dei suoi dati personali viene effettuata registrando i dati da
      lei stesso forniti attraverso il form di richiesta informazioni.
    </p>

    <h4>3. Finalità del trattamento</h4>
    <p>
      I dati personali sono trattati all'unico scopo di permettere la gestione
      della richiesta di informazioni.
    </p>

    <h4>4. Modalità di trattamento dei dati</h4>
    <p>
      In relazione alle finalità descritte, il trattamento dei dati personali
      consiste nel loro invio tramite email al personale addetto.
    </p>

    <h4>5. Facoltatività del conferimento dei dati</h4>
    <p>
      Il conferimento dei dati è richiesto unicamente in caso di volontà di
      ricevere più informazioni sulle funzionalità del sito <NomeSitoPiccolo />.
    </p>

    <h4>6. Categorie di soggetti ai quali i dati possono essere comunicati</h4>
    <p>
      <strong>I suoi dati personali non saranno trasmessi a nessuno.</strong>
    </p>

    <h4>7. Diritti dell'Interessato</h4>
    <p>
      La informiamo, infine, che la normativa in materia di protezione dei dati
      personali conferisce agli Interessati la possibilità di esercitare
      specifici diritti, in base a quanto indicato all’art. 7 del “Codice” che
      qui si riporta:
    </p>
    <p>
      1. L’interessato ha diritto di ottenere la conferma dell’esistenza o meno
      di dati personali che lo riguardano, anche se non ancora registrati, e la
      loro comunicazione in forma intelligibile.
    </p>
    <p>2. L’interessato ha diritto di ottenere l’indicazione:</p>
    <p>a. dell’origine dei dati personali;</p>
    <p>b. delle finalità e modalità del trattamento;</p>
    <p>
      c. della logica applicata in caso di trattamento effettuato con l’ausilio
      di strumenti elettronici;
    </p>
    <p>
      d. degli estremi identificativi del titolare, dei responsabili e del
      rappresentante designato ai sensi dell’art. 5, comma 2;
    </p>
    <p>
      e. dei soggetti o delle categorie di soggetti ai quali i dati personali
      possono essere comunicati o che possono venirne a conoscenza in qualità di
      rappresentante designato nel territorio dello Stato, di responsabili o
      incaricati.
    </p>
    <p>3. L’interessato ha diritto di ottenere:</p>
    <p>
      a. l’aggiornamento, la rettificazione ovvero, quando vi ha interesse,
      l’integrazione dei dati;
    </p>
    <p>
      b. la cancellazione, la trasformazione in forma anonima o il blocco dei
      dati trattati in violazione di legge, compresi quelli di cui non è
      necessaria la conservazione in relazione agli scopi per i quali i dati
      sono stati raccolti o successivamente trattati;
    </p>
    <p>
      c. l’attestazione che le operazioni di cui alle lettere a. e b. sono state
      portate a conoscenza, anche per quanto riguarda il loro contenuto, di
      coloro ai quali i dati sono stati comunicati o diffusi, eccettuato il caso
      in cui tale adempimento si rivela impossibile o comporta un impiego di
      mezzi manifestamente sproporzionato rispetto al diritto tutelato.
    </p>
    <p>4. L’interessato ha diritto di opporsi, in tutto o in parte:</p>
    <p>
      a. per motivi legittimi al trattamento dei dati personali che lo
      riguardano, ancorchè pertinenti allo scopo della raccolta;
    </p>
    <p>
      b. al trattamento di dati personali che lo riguardano a fini di invio di
      materiale pubblicitario o di vendita diretta o per il compimento di
      ricerche di mercato o di comunicazione commerciale.
    </p>

    <h4>8. Titolare e Responsabili del trattamento</h4>
    <p>
      Il Titolare nonché Responsabile del trattamento dei dati personali di cui
      alla presente Informativa è il Sig. Claudio De Nardi, con sede in Via
      Ungheresca Nord, 144 Mareno di Piave (TV).
    </p>
    <p>
      Al fine di semplificare le modalità di inoltro e ridurre i tempi per il
      riscontro, si invita a presentare le richieste, di cui al precedente
      paragrafo, a Claudio De Nardi, contattandolo all’indirizzo email:
      administrator@checkin.loquos.it.
    </p>
    <br />
    <p>L’amministratore</p>
    <br />
    <br />
    <b-btn to="/login" variant="success" style="width: 100%"
      >Ritorna alla Home Page</b-btn
    >
    <br />
    <br />
    <br />
  </div>
</template>

<script>
import NomeSitoPiccolo from "@/components/NomeSitoPiccolo.vue";

export default {
  name: "PrivacySito",
  data() {
    return {};
  },
  components: {
    NomeSitoPiccolo,
  },
  watch: {
    "$store.state.Lingua"(Lingua) {
      fn_CambiaLingua(Lingua, this);
    },
  },
};

function fn_CambiaLingua(lingua, vm) {
  try {
    let labels_italiano = {};
    let labels_inglese = {};
    let labels_tedesco = {};
    let labels_francese = {};

    let labels_errori_italiano = {};
    let labels_errori_inglese = {};
    let labels_errori_tedesco = {};
    let labels_errori_francese = {};

    switch (lingua) {
      case "IT":
        vm.labels = labels_italiano;
        vm.labels_errori = labels_errori_italiano;
        break;
      case "EN":
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
      case "DE":
        vm.labels = labels_tedesco;
        vm.labels_errori = labels_errori_tedesco;
        break;
      case "FR":
        vm.labels = labels_francese;
        vm.labels_errori = labels_errori_francese;
        break;
      default:
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
    }
  } catch (error) {
    vm.registraErrore(
      error,
      "InformativaRichiestaInformazioni-fn_CambiaLingua"
    );
  }
}
</script>
